<div class="pdf-page app-aul-013-24" id="newjersey1324">
  <!-- <app-policy-header></app-policy-header> -->
  <br />
  <p class="font-large" style="text-align: center">
    <b>AMENDATORY ENDORSEMENT</b>
  </p>
  <p class="font-large" style="text-align: center"><b>NEW JERSEY CHANGES</b></p>
  <p class="font-large" style="text-align: center">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY</b>
  </p>
  <p class="font-medium">
    <b>
      This endorsement comprising of policyholder notices, coverage changes and
      endorsements attaches to and forms part of the policy numbered
      {{ this.policyDetails?.policyNo }}
    </b>
  </p>
  <br />
  <p class="font-medium" style="text-decoration: underline">
    <b><u>SURPLUS LINES DISCLOSURE NOTICE (EXHIBIT A-2)</u></b>
  </p>
  <p class="font-medium" style="text-align: justify; width: 95%;">
    <b>
      THIS POLICY IS WRITTEN BY A SURPLUS LINES INSURER AND IS NOT SUBJECT TO
      THE FILING OR APPROVAL REQUIREMENTS OF THE NEW JERSEY DEPARTMENT OF
      BANKING AND INSURANCE. SUCH A POLICY MAY CONTAIN CONDITIONS, LIMITATIONS,
      EXCLUSIONS AND LESS FAVORABLE OR DIFFERENT TERMS THAN A POLICY ISSUED BY
      AN INSURER GRANTED A CERTIFICATE OF AUTHORITY BY THE NEW JERSEY DEPARTMENT
      OF BANKING AND INSURANCE.
    </b>
  </p>
  <p class="font-medium">
    <b>
      THE INSURER HAS BEEN APPROVED BY THE DEPARTMENT AS AN ELIGIBLE SURPLUS
      LINES INSURER, BUT THE POLICY IS NOT COVERED BY THE NEW JERSEY INSURANCE
      GUARANTY FUND, AND ONLY A POLICY OF MEDICAL MALPRACTICE LIABILITY
      INSURANCE AS DEFINED IN N.J.S.A. 17:30D-3D OR A POLICY OF PROPERTY
      INSURANCE COVERING OWNER-OCCUPIED DWELLINGS OF LESS THAN FOUR DWELLING
      UNITS ARE COVERED BY THE NEW JERSEY SURPLUS LINES GUARANTY FUND.
    </b>
  </p>
  <div>
    <div>
      <p class="font-medium">
        <b
          ><span style="text-decoration: underline"
            >SERVICE OF SUIT CLAUSE</span
          ></b
        >
      </p>
    </div>
    <div>
      <p class="font-medium">
        <u>FORTEGRA SPECIALTY INSURANCE COMPANY</u>
      </p>
    </div>
    <ol style="padding-left: 12px" type="I">
      <li>
        In any cause of action arising under this policy, or certificate, cover
        note, or other confirmation of this insurance issued by your surplus
        lines agent, we will, at your request, submit to the jurisdiction of a
        court of competent jurisdiction within the United States. Nothing herein
        constitutes or should be understood to constitute a waiver of our rights
        to commence an action in any court of competent jurisdiction in the
        United States to remove an action to a United States District Court or
        to seek a transfer of a case to another court as permitted by the laws
        of the United States or of any state in the United States. In any suit
        instituted against us upon this policy, we will abide by the final
        decision of such court or of any appellate court in the event of appeal.
      </li>
      <br />
      <li>
        All lawful process may be served in any action, suit or proceeding
        instituted by, or on behalf of, you or any beneficiary under this
        policy, against us arising out of this policy, upon:
        <br />
        <p>
          <b>Corporate Creations Network Inc.</b><br />
          <b>181 New Road #304</b><br />
          <b>Parsippany, NJ 07054</b><br />
          <b>Morris County</b><br />
          <b>REGISTERED AGENT NUMBER: 2141862</b><br />
          <b>Phone: (561) 694-8107</b><br />
        </p>
      </li>
      <br />
      <li>
        Pursuant to any law of any state, the District of Columbia or territory
        of the United States which makes provision therefore, we hereby
        designate the Superintendent, Commissioner or Director of Insurance or
        other applicable individual specified for that purpose in the applicable
        statute or regulation, or his successor or successors in office, as
        attorney or agent for receipt of lawful service of process as our true
        and lawful attorney upon whom may be served any lawful process in any
        action, suit or proceeding instituted by or on behalf of you or any
        beneficiary hereunder arising out of this policy of insurance, and we
        hereby designate the above-named as the person to whom the said
        individual, the surplus lines producer, or any applicable state surplus
        lines association or stamping office, is authorized to mail such process
        or a true copy thereof. The service of process as set forth above and
        below is cumulative to any other methods which may be provided by law
        for service of process upon us.
      </li>
    </ol>
    <p class="font-small">
      ALL OTHER TERMS, CONDITIONS, PROVISIONS AND EXCLUSIONS OF THIS POLICY
      REMAIN THE SAME.
    </p>
  </div>
</div>
